import ProductStack from './Modules/ProductStack'

const initAladdin = function () {
    let productStacks = document.querySelectorAll('.js-product-stack')
    productStacks.forEach((productStack) => new ProductStack(productStack))
}

if (document.readyState !== 'loading') {
    initAladdin()
} else {
    document.addEventListener('DOMContentLoaded', initAladdin)
}
